//Get the button:
mybutton = document.getElementById("myBtn");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 800 || document.documentElement.scrollTop > 800) {
    mybutton.style.opacity = 1;
  } else {
    mybutton.style.opacity = 0;
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

(function($) {
  $(document).ready(function() {
    /*=============================*/
    /*=== Read More / Read Less ===*/
    /*=============================*/
    var txt = 'Read More';
    $(".more").hide();
    $(".more").after('<div class="readmore-container"><a href="#" class="readmore-btn btn"><span class="text">' + txt + '</span></a></div>');
    
    $(".readmore-btn").on("click", function(e) {
      e.preventDefault();
      txt = $(this).parent().prev(".more").is(':visible') ? 'Read More' : 'Read Less';
      $(this).text(txt);
      $(this).parent().prev(".more").slideToggle(200);
    });
  });
  
  $(document).on('click', '.video__block .play__button', function () {
    var me = $(this);
    var iframe = me.closest('.video__block').find('iframe');
    var vidsrc = iframe.data('src');
    
    vidsrc = vidsrc.replace("watch?v=", "embed/");
    
    iframe.attr('src', vidsrc);
    me.closest('.video__block').addClass('video__loaded');
  })
})(jQuery);